import React, { Component } from 'react'
import styled from 'styled-components'
import Table from '../../components/Table'
import Modal from '../Modal'
import { pxToRem, color } from '../../utils'
import { connect } from 'react-redux'
import { productMapActions, inventoryActions } from '../../actions'
import statusSuccessIcon from '../../assets/icons/status-success.svg'
import editIcon from '../../assets/icons/edit.svg'
import { Flex } from '../Flex'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''
const USE_OUTPUT_ATTACHMENTS = process.env.REACT_APP_USE_OUTPUT_ATTACHMENTS === 'y'

const WrapperExport = styled.div`
  float: left;
  h2 {
    font-size: ${pxToRem(16)};
    display: block;
    margin-top: 0;
    margin-bottom: 0;
  }
`
const WrapperExportButton = styled.div`
  float: left;
  margin-bottom: ${pxToRem(25)};
  h2 {
    font-size: ${pxToRem(16)};
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
  }
  a {
    font-size: ${pxToRem(16)};
    color: ${color.secondary};
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    &:visited {
      color: ${color.secondary};
    }
  }
`

const WrapperStatus = styled(Flex)`
  width: 20px;
  height: 20px;
  margin: auto;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
  ${({ type }) => {
    return `
      background: ${type === 'success' ? color.success : color.warning}
      img{
        width: ${type === 'success' ? pxToRem('15px') : pxToRem('5px')}
      }
    `
  }};
`

const Action = styled.img`
  width: ${pxToRem('25px')};
  height: 20px;
  margin: 5px;
  display: inline-block;
  cursor: pointer;
`

const WrapperActions = styled.div`
  text-align: center;
`

const ExportLink = styled.i`
  cursor: pointer;
  font-size: ${pxToRem(16)};
  color: ${color.secondary};
  display: inline-block;
  text-decoration: underline;
  &:visited {
    color: ${color.secondary};
  }
`

const WrapperButton = styled.div`
  margin-bottom: ${pxToRem(10)};
  display: flex;
  text-align: right;
  width: 100%;
  div {
    vertical-align: bottom;
  }
`

const ExportXls = styled(ExportLink)`
  margin-right: 5px;
`

const ExportPdf = styled(ExportLink)`
  margin-left: 5px;
`

const WrapperInput = styled.div`
  color: #0066ff;
`

const WrapperOutput = styled.div`
  color: #ff0000;
`

class HistoricModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      historic: {},
      open: false,
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(props) {
    this.setState(state => ({
      historic: [],
      open: props.open,
      productId: props.productId,
      areaId: props.areaId,
    }))
    this.setDefaultValue()
  }

  setDefaultValue() {
    this.setState(state => ({
      historic: {
        amount: 0,
        amountPackage: 0,
        ...state.historic
      }
    }))
  }

  closeModal = () => {
    this.props.closeMethod()
  }

  downloadXls = () => {
    this.props.fetchProductHistoricDownloadXls(this.props.currentAreaId, this.props.productId, this.props.productBatch)
  }

  downloadPdf = () => {
    this.props.fetchProductHistoricDownloadPdf(this.props.currentAreaId, this.props.productId, this.props.productBatch)
  }

  openFile = url => {
    if (!!url) {
      window.open(url, '_blank')
    }
  }

  render() {
    const columns = {
      id: {
        hide: true
      },
      transaction_date: {
        label: 'Data - Hora',
        sortable: true,
        width: pxToRem(100)
      },
      transaction_type: {
        label: 'Entrada/Saída',
        sortable: true,
        width: pxToRem(100),
        CellComponent: historicData => {
          if(historicData.value === 'Entrada') {
            return <WrapperInput>{historicData.value}</WrapperInput>
          } else {
            return <WrapperOutput>{historicData.value} </WrapperOutput>
          }
        }
      },
      amount: {
        label: 'Quantidade',
        sortable: true,
        width: pxToRem(100)
      },
      observation: {
        label: 'Motivo',
        sortable: true,
        width: pxToRem(100)
      },
      invoice_url: {
        label: 'NF',
        align: 'center',
        width: pxToRem(20)
      },
      certificate_url: {
        label: 'Certificado',
        width: pxToRem(10),
        align: 'center',
      },
      user_name: {
        label: 'Responsável',
        width: pxToRem(100)
      }
    }

    const InvoiceCellComponent = ({ name, value, row, ...rest }) => {
      return (
        row && row.invoice_url === '---' ? (
          <Flex>
            ---
          </Flex>
        ) : (
          <WrapperStatus type="success">
            <Action src={statusSuccessIcon} onClick={e => openFile(row.invoice_url)} alt="NF Status" />
          </WrapperStatus>
        )
      )
    }

    columns['invoice_url'] = {
      ...columns['invoice_url'],
      CellComponent: InvoiceCellComponent
    }

    const CertificateCellComponent = ({ name, value, row, ...rest }) => {
      return (
        row && row.certificate_url === '---' ? (
          <Flex>
            ---
          </Flex>
        ) : (
          <WrapperStatus type="success">
            <Action src={statusSuccessIcon} onClick={e => openFile(row.certificate_url)} alt="Certificate Status" />
          </WrapperStatus>
        )
      )
    }

    columns['certificate_url'] = {
      ...columns['certificate_url'],
      CellComponent: CertificateCellComponent
    }

    const ActionsCellComponent = ({ name, value, row, ...rest }) => {
      return (
        row && row.transaction_type === 'Saída' ? (
          <WrapperActions>
            <Action src={editIcon} onClick={e => this.props.onEditOutput(row)} alt="Editar saída" />
          </WrapperActions>
        ) : (
          <Flex />
        )
      )
    }

    if (USE_OUTPUT_ATTACHMENTS && typeof this.props.onEditOutput === 'function') {
      columns['actions'] = {
        label: 'Ações',
        align: 'center',
        width: pxToRem(20),
        CellComponent: ActionsCellComponent
      }
    }

    const {
      downloadXls,
      downloadPdf,
      openFile
    } = this

    const {
      name,
      open = false,
      size,
      title,
      method,
      loading = false,
      closeMethod,
      historicData,
      productName,
      pagination
    } = this.props

    return (
      <Modal
        title={`${title}: ${productName}`}
        name={name}
        open={open}
        size={size}
        method={method}
        loading={loading}
        closeMethod={closeMethod}
      >
        <WrapperButton>
          <WrapperExport>
            <h2>Exportar Para: </h2>
            <WrapperExportButton>
              <ExportXls
                onClick={e => {
                  downloadXls()
                }}
              >
                EXCEL
              </ExportXls>
              |
              <ExportPdf
                onClick={e => {
                  downloadPdf()
                }}
              >
                PDF
              </ExportPdf>
            </WrapperExportButton>
          </WrapperExport>
        </WrapperButton>
        <Table
          onChangePage={(newPage, rowsPerPage) => this.props.onChangePage(newPage, rowsPerPage)}
          onChangeRowsPerPage={(rowsPerPage, currentPage) => this.props.onChangeRowsPerPage(rowsPerPage, currentPage)}
          onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
            this.props.onChangeOrderBy(orderBy, order, currentPage, rowsPerPage)
          }
          columns={columns} 
          height={'48vh'} 
          width={1100} 
          data={historicData} 
          pagination={pagination || {}} 
          colSpan={5}
          defaultSort={{ key: 'created_at', reverse: true }}
          />
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.auth.userName,
  currentUserId: state.auth.userId,
  currentArea: state.auth.areaName,
  currentAreaId: state.auth.areaId,
  productList: state.productMap.items,
  searchText: state.search.searchText,
  canChangeArea: state.auth.canChangeArea
})

const mapDispatchToProps = dispatch => {
  return {
    fetchProductList: areaId => {
      dispatch(productMapActions.fetchCollectionProductsByInventory(areaId))
    },
    fetchProductHistoricDownloadXls: (areaId, productId, batch) => {
      dispatch(inventoryActions.fetchProductHistoricDownloadXls(areaId, productId, batch))
    },
    fetchProductHistoricDownloadPdf: (areaId, productId, batch) => {
      dispatch(inventoryActions.fetchProductHistoricDownloadPdf(areaId, productId, batch))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoricModal)



// WEBPACK FOOTER //
// ./src/components/Inventory/HistoricModal.js